import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import { ACCEPT_INVITATION } from '../../../graphql/mutation'
import { VALIDATE_MEMBER_INVITATION } from '../../../graphql/query'
import { toast } from 'react-toastify'

const initialValues = {
  email: '',
  password: '',
  changepassword: ''
}

const registrationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),

  password: Yup.string()
    .min(10, 'Password must be at least 10 characters long')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=\S{8,})/,
      'Must contain at least 8 characters, one uppercase, one lowercase, one number, and one special character without spaces'
    )
    .required('Password is required'),
  changepassword: Yup.string()
    .required('Password confirmation is required')
    .when('password', {
      is: (val: string) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('password')], "Password and Confirm Password didn't match")
    })
})

export const ResetPassword: React.FC = () => {
  const params = useParams()
  const uuid = params.uuid
  const [acceptInvitation] = useMutation(ACCEPT_INVITATION)
  const [loadingOL, setLoading] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const userRef = useRef<any>(null)
  let [userId, setUserId] = useState<number>(0)
  const navigate = useNavigate()

  const {
    loading: loadingValidation,
    error: errorValidation,
    data: dataValidation
  } = useQuery(VALIDATE_MEMBER_INVITATION, {
    variables: {
      input: {
        uuid: uuid
      }
    }
  })
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      acceptInvitation({
        variables: {
          input: {
            name: dataValidation.validateMemberInvitation.data.updatedUser.name,
            id: userId,
            password: values.password
          }
        }
      })
        .then((res: any) => {
          setLoading(false)
          toast.success('Password Reset successfully')
          navigate('/auth/login')
        })
        .catch((err) => {
          console.log(err)
        })
    }
  })

  useEffect(() => {
    if (!!userRef.current) {
      setUserId(userRef.current.id)
    }
  }, [userRef.current])

  if (loadingValidation) {
    return <div className='text-dark fs-4 text-center'>Please wait...</div>
  }

  if (errorValidation) {
    return (
      <>
        <h3>Oops! Error</h3>
      </>
    )
  }

  console.log(dataValidation)
  if (dataValidation) {
    // status 498 --> Invitation expired
    // status 400 --> Invalid Invitation
    if (dataValidation.validateMemberInvitation.status === 200) {
      userRef.current = dataValidation.validateMemberInvitation.data.updatedUser
      formik.initialValues.email = dataValidation.validateMemberInvitation.data.updatedUser.email
      // Check If the user has already accepted the Invitation
      if (dataValidation.validateMemberInvitation.data.updatedUser.status === 'Active') {
        return (
          <>
            <div className='text-dark fs-4 mb-8 fw-bold text-center'>
              You have already accepted this Invitation!
            </div>
            <div className='text-gray-400 fw-bolder fs-4 mt-8 text-center'>
              <Link
                to='/auth/login'
                className='link-primary fw-bolder'
                style={{ marginLeft: '5px' }}
              >
                Log In
              </Link>
              {'  '} to continue
            </div>
          </>
        )
      }
    } else {
      return (
        <>
          <div className='text-dark fs-4 fw-bold text-center'>
            {dataValidation.validateMemberInvitation.message}
          </div>
        </>
      )
    }
  }

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword)
  }
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword)
  }

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className='mb-10 text-center'>
        {/* begin::Title */}
        <h1 className='text-dark mb-3'>Set Password</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-gray-400 fw-bold fs-4'>
          We are excited to have you in botgo
          {/* <Link to='/auth/login' className='link-primary fw-bolder' style={{ marginLeft: '5px' }}>
            Log In
          </Link> */}
        </div>
        {/* end::Link */}
      </div>
      {/* end::Heading */}

      {/* begin::Action */}
      {/* <button type='button' className='btn btn-light-primary fw-bolder w-100 mb-10'>
    <img
      alt='Logo'
      src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
      className='h-20px me-3'
    />
    Sign in with Google
  </button> */}
      {/* end::Action */}

      {/* <div className='d-flex align-items-center mb-10'>
    <div className='border-bottom border-gray-300 mw-50 w-100'></div>
    <span className='fw-bold text-gray-400 fs-7 mx-2'>OR</span>
    <div className='border-bottom border-gray-300 mw-50 w-100'></div>
  </div> */}

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* end::Form group */}

      {/* end::Form group */}

      {/* begin::Form group Email */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>Email</label>
        <input
          placeholder='Email'
          type='email'
          // disabled={!!userRef.current.email ? true : false}
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            {
              'is-valid': formik.touched.email && !formik.errors.email
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Password */}
      <div className='mb-10 fv-row'>
        <div className='mb-1'>
          <label className='form-label fw-bolder text-dark fs-6'>Password</label>
          <div className='position-relative mb-3 d-flex'>
            <input
              type={showNewPassword ? 'text' : 'password'}
              placeholder='Password'
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.password && formik.errors.password
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password
                }
              )}
              style={{
                borderRadius: '5px 0px 0px 5px' // Adjust the border radius as needed
              }}
            />
            <div className='input-group-append'>
              <span
                className='form-control form-control-lg form-control-solid'
                id='togglePassword'
                onClick={toggleNewPasswordVisibility}
                style={{
                  cursor: 'pointer',
                  borderRadius: '0px 5px 5px 0px' // Adjust the border radius as needed
                }}
              >
                {showNewPassword ? (
                  <i className='bi bi-eye-slash text-dark'></i>
                ) : (
                  <i className='bi bi-eye text-dark'></i>
                )}
              </span>
            </div>
          </div>
          {formik.touched.password && formik.errors.password && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.password}</span>
              </div>
            </div>
          )}
        </div>
        <div className='text-muted'>
          Use 8 or more characters with a mix of letters, numbers & symbols.
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group Confirm password */}
      <div className='fv-row mb-5'>
        <label className='form-label fw-bolder text-dark fs-6'>Confirm Password</label>
        <div className='position-relative mb-3 d-flex'>
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            placeholder='Confirm password'
            autoComplete='off'
            {...formik.getFieldProps('changepassword')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.changepassword && formik.errors.changepassword
              },
              {
                'is-valid': formik.touched.changepassword && !formik.errors.changepassword
              }
            )}
            style={{
              borderRadius: '5px 0px 0px 5px' // Adjust the border radius as needed
            }}
          />
          <div className='input-group-append'>
            <span
              className='form-control form-control-lg form-control-solid'
              id='togglePassword'
              onClick={toggleConfirmPasswordVisibility}
              style={{
                cursor: 'pointer',
                borderRadius: '0px 5px 5px 0px' // Adjust the border radius as needed
              }}
            >
              {showConfirmPassword ? (
                <i className='bi bi-eye-slash text-dark'></i>
              ) : (
                <i className='bi bi-eye text-dark'></i>
              )}
            </span>
          </div>
        </div>
        {formik.touched.changepassword && formik.errors.changepassword && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.changepassword}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}

      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loadingOL && <span className='indicator-label'>Submit</span>}
          {loadingOL && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary w-100 mb-5'
          >
            Cancel
          </button>
        </Link>
      </div>
      {/* end::Form group */}
    </form>
  )
}
